export const SET_PROFILE = 'setProfile'
export const SET_PERMISSIONS = 'setPermissions'
export const SET_USES = 'setUses'
export const CLEAR_PROFILE = 'clearProfile'
export const SET_DISCARDED_PERMISSION = 'setDiscardedPermission'
export const SET_REASONS_LIST = 'setReasonsList'
